import { UuidIdGenerator } from '../../../common'
import { SalesPoint, SalesPointType } from './salesPoints'
import { faker } from '@faker-js/faker/locale/ru'

export function mockSalesPoint(opts?: Partial<SalesPoint>): SalesPoint {
  const type = [SalesPointType.FOOD, SalesPointType.NON_FOOD, SalesPointType.MIXED][Math.floor(Math.random() * 3)]
  const municipalEntityId = faker.number.int({ min: 0, max: 20 })
  const idGenerator = new UuidIdGenerator()

  return {
    type,
    name: faker.company.name(),
    inn: faker.string.numeric(10),
    maxPopulation: faker.number.float({ precision: 0.1, min: 1, max: 50 }),
    notificationMark: `№${faker.number.int({ min: 1, max: 50 })} от ${faker.date
      .anytime()
      .toLocaleDateString('ru-RU')}`,
    id: idGenerator.generate(),
    createdAt: new Date(),
    municipalEntityId: municipalEntityId.toString(),
    locality: faker.location.city(),
    street: faker.location.street(),
    building: faker.location.buildingNumber(),
    comment: faker.lorem.paragraph(1),
    openingHours: faker.date.weekday({ context: true }),
    phone: faker.phone.number('7##########'),
    area: faker.number.int({ min: 10, max: 80 }),
    responsiblePersonName: faker.person.fullName(),
    ...opts,
  }
}
